// assessmentData.js

const baseQuestionsSet1 = [
  { id: "s1q1", label: "We have written Standard Operating Procedures (SOPs) for all key activities.", pillar: "Process" },
  { id: "s1q2", label: "Our operations follow defined steps consistently, even when the owner is not present.", pillar: "Process" },
  { id: "s1q3", label: "We monitor process performance (time, cost, output) regularly.", pillar: "Process" },

  { id: "s1q4", label: "Quality is checked during the process, not just at the end.", pillar: "Quality" },
  { id: "s1q5", label: "We use any formal quality or certification system (ISO, HACCP, ZED, etc.).", pillar: "Quality" },
  { id: "s1q6", label: "We record and analyse rejection, rework, or defect data to improve quality.", pillar: "Quality" },

  { id: "s1q7", label: "We use digital tools (ERP, CRM, MIS, or farm apps) for operations tracking.", pillar: "Data" },
  { id: "s1q8", label: "Data from digital systems is analysed to make decisions or improvements.", pillar: "Data" },
  { id: "s1q9", label: "Our business records (finance, production, inventory) are digital and updated in real time.", pillar: "Data" },

  { id: "s1q10", label: "Employees are trained on SOPs and basic quality or lean concepts.", pillar: "People" },
  { id: "s1q11", label: "Roles and responsibilities are clearly defined and documented.", pillar: "People" },
  { id: "s1q12", label: "We encourage employees to suggest improvements and innovations.", pillar: "People" },

  { id: "s1q13", label: "We maintain updated digital financial records and cost sheets.", pillar: "Finance" },
  { id: "s1q14", label: "We regularly review financial performance (P&L, cash flow, profitability).", pillar: "Finance" },
  { id: "s1q15", label: "We follow sustainable or resource-efficient practices (waste, energy, packaging, etc.).", pillar: "Sustainability" },
];

const baseQuestionsSet2 = [
  { id: "s2q1", label: "We regularly review and update our SOPs based on feedback or changes in operations.", pillar: "Process" },
  { id: "s2q2", label: "Our workflow is optimized to avoid bottlenecks and unnecessary steps.", pillar: "Process" },
  { id: "s2q3", label: "We track key process timelines (order cycle time, production time, service time).", pillar: "Process" },

  { id: "s2q4", label: "We have a structured system to handle customer complaints and defects.", pillar: "Quality" },
  { id: "s2q5", label: "Quality checks are documented and reviewed regularly.", pillar: "Quality" },
  { id: "s2q6", label: "We perform root-cause analysis (RCA) for major defects and implement corrective actions.", pillar: "Quality" },

  { id: "s2q7", label: "We maintain a central digital repository of business documents and records.", pillar: "Data" },
  { id: "s2q8", label: "We use dashboards or summary reports to review business performance.", pillar: "Data" },
  { id: "s2q9", label: "We use digital tools to monitor inventory, orders, or material usage.", pillar: "Data" },

  { id: "s2q10", label: "We conduct skill development or capability building sessions periodically.", pillar: "People" },
  { id: "s2q11", label: "Employees are evaluated based on clearly defined KPIs or responsibilities.", pillar: "People" },
  { id: "s2q12", label: "We recognize or reward employees who contribute improvement ideas.", pillar: "People" },

  { id: "s2q13", label: "Our costing and pricing methods are consistent and based on real data.", pillar: "Finance" },
  { id: "s2q14", label: "We maintain a budget and compare it regularly with actual performance.", pillar: "Finance" },
  { id: "s2q15", label: "We actively track and aim to reduce wastage, scrap, or resource misuse.", pillar: "Sustainability" },
];

const baseQuestionsSet3 = [
  { id: "s3q1", label: "We map all key processes visually (flowcharts or process maps).", pillar: "Process" },
  { id: "s3q2", label: "We have clear process handovers between departments or roles.", pillar: "Process" },
  { id: "s3q3", label: "We regularly identify and eliminate unnecessary manual tasks.", pillar: "Process" },

  { id: "s3q4", label: "Quality parameters are defined for each product or service stage.", pillar: "Quality" },
  { id: "s3q5", label: "We maintain proper calibration and maintenance logs for tools & equipment.", pillar: "Quality" },
  { id: "s3q6", label: "We use structured checklists for quality audits or inspections.", pillar: "Quality" },

  { id: "s3q7", label: "We follow a defined process for storing, securing, and backing up digital data.", pillar: "Data" },
  { id: "s3q8", label: "We analyse trends in key data (production, sales, quality, cost).", pillar: "Data" },
  { id: "s3q9", label: "We use digital tools for communication, reporting, or team coordination.", pillar: "Data" },

  { id: "s3q10", label: "We onboard new employees with a structured orientation process.", pillar: "People" },
  { id: "s3q11", label: "We conduct periodic performance discussions with team members.", pillar: "People" },
  { id: "s3q12", label: "Employees are empowered to raise issues or suggest changes openly.", pillar: "People" },

  { id: "s3q13", label: "We use reliable methods to forecast expenses and revenues.", pillar: "Finance" },
  { id: "s3q14", label: "We track receivables and payables systematically to manage cash flow.", pillar: "Finance" },
  { id: "s3q15", label: "We track environmental impact areas (energy, water, waste, emissions).", pillar: "Sustainability" },
];


// ✅ **Set 4 (Higher maturity: automation, integration, advanced controls)**
const baseQuestionsSet4 = [
  { id: "s4q1", label: "Our processes are partially automated or system-driven to reduce manual work.", pillar: "Process" },
  { id: "s4q2", label: "We benchmark our processes against industry standards for improvement.", pillar: "Process" },
  { id: "s4q3", label: "We use KPIs to evaluate process efficiency and take improvement actions.", pillar: "Process" },

  { id: "s4q4", label: "We use statistical tools (SPC, Pareto, fishbone) for quality analysis.", pillar: "Quality" },
  { id: "s4q5", label: "We track supplier quality and maintain evaluation records.", pillar: "Quality" },
  { id: "s4q6", label: "We have preventive maintenance schedules to ensure consistent quality.", pillar: "Quality" },

  { id: "s4q7", label: "We integrate data from multiple sources (finance, inventory, production).", pillar: "Data" },
  { id: "s4q8", label: "We use trend analysis to predict issues and take preventive actions.", pillar: "Data" },
  { id: "s4q9", label: "We use automated alerts or notifications for key metrics.", pillar: "Data" },

  { id: "s4q10", label: "We have leadership development and structured training programs.", pillar: "People" },
  { id: "s4q11", label: "We have succession planning for critical roles.", pillar: "People" },
  { id: "s4q12", label: "We conduct regular employee satisfaction or engagement assessments.", pillar: "People" },

  { id: "s4q13", label: "We analyse financial ratios to assess business health and plan improvements.", pillar: "Finance" },
  { id: "s4q14", label: "We use cost-benefit or ROI analysis for investment decisions.", pillar: "Finance" },
  { id: "s4q15", label: "We run sustainability initiatives with measurable yearly targets.", pillar: "Sustainability" },
];


// ✅ **Set 5 (Highest maturity: predictive, lean, continuous improvement, advanced digitalisation)**
const baseQuestionsSet5 = [
  { id: "s5q1", label: "Processes are fully optimized using automation or digital workflows.", pillar: "Process" },
  { id: "s5q2", label: "We continuously improve processes using lean or six-sigma methods.", pillar: "Process" },
  { id: "s5q3", label: "We use predictive analytics to anticipate demand, delays, or resource issues.", pillar: "Process" },

  { id: "s5q4", label: "We conduct advanced quality analysis (FMEA, capability studies).", pillar: "Quality" },
  { id: "s5q5", label: "We have end-to-end quality traceability for materials, processes, and output.", pillar: "Quality" },
  { id: "s5q6", label: "We follow continuous improvement cycles (PDCA/Kaizen) with targets.", pillar: "Quality" },

  { id: "s5q7", label: "We use integrated digital systems (ERP/MRP/CRM) for all major operations.", pillar: "Data" },
  { id: "s5q8", label: "We use predictive insights from data to guide decision-making.", pillar: "Data" },
  { id: "s5q9", label: "We measure digital maturity and continuously upgrade systems.", pillar: "Data" },

  { id: "s5q10", label: "We have a high-performance culture with continuous capability building.", pillar: "People" },
  { id: "s5q11", label: "We use data-driven methods for talent development and performance.", pillar: "People" },
  { id: "s5q12", label: "Teams take ownership for improvements through autonomous work practices.", pillar: "People" },

  { id: "s5q13", label: "We use financial forecasting models for strategic planning.", pillar: "Finance" },
  { id: "s5q14", label: "We integrate financial dashboards with operational metrics.", pillar: "Finance" },
  { id: "s5q15", label: "We follow global sustainability practices and track carbon footprint.", pillar: "Sustainability" },
];


export const agriExtras = [
  { id: "a1", label: "We maintain full traceability from farmer to final product.", pillar: "Traceability" },
  { id: "a2", label: "We follow hygiene and food-safety protocols (FSSAI, GMP).", pillar: "Traceability" },
  { id: "a3", label: "We measure post-harvest losses and continuously improve process efficiency.", pillar: "Sustainability" },
];


export const allSets = {
  1: baseQuestionsSet1,
  2: baseQuestionsSet2,
  3: baseQuestionsSet3,
  4: baseQuestionsSet4,
  5: baseQuestionsSet5,
};
